module["exports"] = ["gmail.com", "yahoo.com", "hotmail.com", "live.com", "bol.com.br"];